import { createFileRoute } from '@tanstack/react-router'

import { EvaluationsScreen } from '@/features/evaluations/evaluations-screen'
import { evaluationsSearchSchema } from '@/features/evaluations/evaluations-search'

/** Where the day starts: the evaluations list, its tab, filters, sort and page in the address. */
export const Route = createFileRoute('/_app/_org/evaluations/')({
  validateSearch: evaluationsSearchSchema,
  component: EvaluationsScreen,
})
